import * as React from 'react';

import Power16 from './Power16';

export const power16 = () => <Power16 />;

export default {
    title: 'Icon/Line/Power16',
    component: Power16,
    parameters: {
        notes: "`import Power16 from 'box-ui-elements/es/icon/line/Power16';`",
    },
};
